<div class="translate grid-wrapper">
  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }
  <!-- || editorType.toString() == 'FlowOwners' -->
  <kendo-toolbar>
    <kendo-toolbar-buttongroup [selection]="'multiple'">
      <!-- <ng-container *ngIf="editorType.toString() == 'Flow' || editorType.toString() == 'FlowAdvanced' || editorType.toString() == 'Connection' "> -->
      <!-- <kendo-toolbar-button [icon]="'save'" [text]="'Save'" (click)="onSaveClick()"></kendo-toolbar-button> -->
    <!-- </ng-container> -->
    <kendo-toolbar-button [icon]="'close-circle'" [text]="'Cancel'" (click)="close()"></kendo-toolbar-button>
  </kendo-toolbar-buttongroup>
</kendo-toolbar>
<div style="display: flex;">
  <div style="flex: 50%">
    <ngx-monaco-editor class="monaco-editor" [options]="xmlEditorOptions" [(ngModel)]="xmlCode" (onInit)="onInitXml($event)"></ngx-monaco-editor>
  </div>
  <div style="flex: 50%">
    <ngx-monaco-editor class="monaco-editor" [options]="jsonEditorOptions" [(ngModel)]="jsonCode" (onInit)="onInitJson($event)"></ngx-monaco-editor>
  </div>
</div>
@if (!this.ready) {
  <div class="k-i-loading"></div>
}
</div>